import { getTraceId } from '@atlassian/jira-fetch/src/utils/trace-id.tsx';
import { ExportIssuesDownloadError, type ExportIssuesDownloadErrorResponse } from '../../types.tsx';

export const downloadFile = async ({
	downloadUrl,
	signal,
}: {
	downloadUrl: string;
	signal?: AbortSignal;
}): Promise<void> => {
	const response = await fetch(downloadUrl, { signal });

	if (response.status === 200) {
		const filename = getFilename(response);
		const blob = await response.blob();

		if (!__SERVER__) {
			const link = document.createElement('a');
			link.href = URL.createObjectURL(blob);
			link.download = filename;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
	} else {
		const errorResponse: ExportIssuesDownloadErrorResponse = await response.json();

		const traceId = getTraceId(response);

		const fetchError = new ExportIssuesDownloadError({
			statusCode: response.status,
			message: errorResponse.message,
			traceId,
			errorCode: errorResponse.errorCode,
			response,
		});

		throw fetchError;
	}
};

const getFilename = (response: Response) => {
	const contentDisposition = response.headers.get('content-disposition');

	if (contentDisposition) {
		const filenameMatch = contentDisposition.match(/filename="(.+)"/);

		if (filenameMatch) {
			return filenameMatch[1];
		}
	}

	return 'Jira.csv';
};
